// extracted by mini-css-extract-plugin
export var hideEditor = "_m8-2";
export var infoIcon = "_m8-3";
export var label = "_m8-1";
export var labelContainer = "_m8-0";
export var readonlyText = "_m8-4";